import {
  TRUSTWAVE_CERT_POPUP_FEATURES,
  TRUSTWAVE_CERT_POPUP_WINDOW_NAME,
  TRUSTWAVE_CONTEXT_MENU_MESSAGE,
  TRUSTWAVE_SEAL_ALT,
  TRUSTWAVE_SEAL_URLS,
} from '@/constants/trustwave'

export function PaymentTrustwaveSeal() {
  return (
    <div className="mt-4 ml-4">
      <img
        id="trustwaveSealImage"
        src={TRUSTWAVE_SEAL_URLS.sealImage}
        style={{ cursor: 'pointer', border: 0 }}
        onClick={() => {
          window.open(
            TRUSTWAVE_SEAL_URLS.certPopup,
            TRUSTWAVE_CERT_POPUP_WINDOW_NAME,
            TRUSTWAVE_CERT_POPUP_FEATURES,
          )
        }}
        onContextMenu={(e) => {
          e.preventDefault()
          alert(TRUSTWAVE_CONTEXT_MENU_MESSAGE)
        }}
        alt={TRUSTWAVE_SEAL_ALT}
        title={TRUSTWAVE_SEAL_ALT}
      />
    </div>
  )
}
